import { render, staticRenderFns } from "./MobileCaseSample.vue?vue&type=template&id=720466e1&lang=pug"
import script from "./MobileCaseSample.vue?vue&type=script&lang=js"
export * from "./MobileCaseSample.vue?vue&type=script&lang=js"
import style0 from "./MobileCaseSample.vue?vue&type=style&index=0&id=720466e1&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports